export const DEFAULT_CURRENCY = "INR";

export const RETRIEVING_DATA_SUBTITLE = "Please wait while we retrieve your data";